import { fieldNamePrefix } from "./constants";

//=======================================================================================================
//
//                 ######   ######## ##    ## ######## ########     ###    ##       
//                ##    ##  ##       ###   ## ##       ##     ##   ## ##   ##       
//                ##        ##       ####  ## ##       ##     ##  ##   ##  ##       
//                ##   #### ######   ## ## ## ######   ########  ##     ## ##       
//                ##    ##  ##       ##  #### ##       ##   ##   ######### ##       
//                ##    ##  ##       ##   ### ##       ##    ##  ##     ## ##       
//                 ######   ######## ##    ## ######## ##     ## ##     ## ########
//
//=======================================================================================================

export const clone = data => {
    return JSON.parse(JSON.stringify(data));
};

export const createArray = (dim, bounds, defaultVal = "", _arr = undefined) => {

    if (typeof _arr === "undefined") {
        _arr = [];
    }

    let len = bounds.slice().reverse()[dim-1];

    if (dim > 1) {
        for (let i = 0; i < len; i++) {
            _arr[i] = createArray(dim - 1, bounds, defaultVal, _arr[i]);
        }
        return _arr;
    } 
    else {
        for (let i = 0; i < len; i++) {
            _arr[i] = clone(defaultVal);
        }
        return _arr;
    }

    //---------------------------------------------------------------------------------------------------
    // Passing tests
    //
    // let a = createArray(1, [3], "test");               a[0] = "different"; console.log(a);
    // let b = createArray(1, [3], {test: "test"});       b[0].test = "different"; console.log(b);
    
    // let c = createArray(2, [3, 3], "test");            c[0][0] = "different"; console.log(c);
    // let d = createArray(2, [3, 3], {test: "test"});    d[0][0].test = "different"; console.log(d);
    
    // let e = createArray(2, [5, 6], "test");            e[0][0] = "different"; console.log(e);
    // let f = createArray(2, [5, 6], {test: "test"});    f[0][0].test = "different"; console.log(f);
    
    // let g = createArray(3, [1, 2, 3], "test");         g[0][0][0] = "different"; console.log(g);
    // let h = createArray(3, [1, 2, 3], {test: "test"}); h[0][0][0].test = "different"; console.log(h);

    // let g = createArray(10, [1, 2, 3, 4, 5, 6, 7, 8, 9, 10], "test"); console.log(g);
    //---------------------------------------------------------------------------------------------------

    //---------------------------------------------------------------------------------------------------
    // Notes
    //
    // TGP: Bad! Elements by reference
    //     return Array(length).fill(clone(value));
    //
    // TGP : Bad!  Elements by reference
    //     let len = bounds.shift();
    //
    //     if (dim > 1) {
    //         return Array.from({length: len}, x => createArray(dim - 1, clone(bounds), value));
    //     } else {
    //         return Array(len).fill(value);
    //     }
    //---------------------------------------------------------------------------------------------------
};

export const createVector = (length, defaultVal = 0) => {

    return createArray(1, [length], defaultVal);

    // let arr = [];

    // for (let r = 0; r < length; r++) {
    //     arr[r] = clone(defaultVal);
    // }
    
    // return arr;

    //--------------------------------------------------------------------------------------
    // Passing tests
    //
    // let a = createVector(2, { intArray: [] }); a[0].intArray = [2]; console.log(a);
    //--------------------------------------------------------------------------------------

    //--------------------------------------------------------------------------------------
    // Notes
    //
    // TGP: Bad! Elements by reference
    // return Array(length).fill(clone(value));
    //--------------------------------------------------------------------------------------  
};

export const createMatrix = (rowCount, columnCount, defaultVal = 0) => {  

    return createArray(2, [rowCount, columnCount], defaultVal);

    // let arr = [];

    // for (let r = 0; r < rowCount; r++) {
    //     arr[r] = [];
    //     for (let c = 0; c < columnCount; c++) {
    //         arr[r][c] = clone(defaultVal);
    //     }
    // }
    
    // return arr;

    //--------------------------------------------------------------------------------------
    // Passing tests
    //
    // let a = createMatrix(2, 2, { intArray: [] }); a[0][0].intArray = [2]; console.log(a);
    //--------------------------------------------------------------------------------------

    //--------------------------------------------------------------------------------------
    // Notes
    //
    // TGP: Bad! Elements by reference
    // return Array.from({length: rowCount}, x => Array(columnCount).fill(clone(value)));
    //
    // TGP: Bad! Elements by reference
    // return Array(rowCount).fill(Array(columnCount).fill(value));  
    //--------------------------------------------------------------------------------------
};

export const size1dArray = (array, len, defaultVal = 0) => {
    let array2 = [];

    for (let x = 0; x < len; x++) {
        array2[x] = defaultVal;
    }

    for (let r = 0; r < array.length; r++) {
        if (array2.length > r) {
            array2[r] = array[r];
        }
    }

    //--------------------------------------------------------------------------------------
    // Passing tests
    //
    // let a = size1dArray([], 3, ""); console.log(a);
    // let b = size1dArray([0], 3, ""); console.log(b);
    // let c = size1dArray([0, 0], 3, ""); console.log(c);
    // let d = size1dArray([0, 0, 0], 3, ""); console.log(d);
    // let e = size1dArray([0, 0, 0, 0], 3, ""); console.log(e);
    //--------------------------------------------------------------------------------------

    return array2;
};

export const size2dArray = (array, row, col, defaultVal = 0) => {
    let array2 = [];

    for (let x = 0; x < row; x++) {
        array2[x] = [];
        for (let y = 0; y < col; y++) {
            array2[x][y] = clone(defaultVal);
        }
    }

    for (let r = 0; r < array.length; r++) {
        if (array2.length > r) {
            for (let c = 0; c < array[r].length; c++) {
                if (array2[r].length > c) {
                    array2[r][c] = array[r][c];
                }
            }
        }
    }

    //--------------------------------------------------------------------------------------
    // Passing tests
    //
    // let a = size2dArray([[]], 3, 3, ""); console.log(a);
    // let b = size2dArray([[0, 0]], 3, 3, ""); console.log(b);
    // let c = size2dArray([[0, 0], [0, 0]], 3, 3, ""); console.log(c);
    // let d = size2dArray([[0, 0], [0, 0], [0, 0]], 3, 3, ""); console.log(d);
    // let e = size2dArray([[1, 2], [3, 4], [5, 6], [7, 8]], 3, 3, ""); console.log(e);
    //--------------------------------------------------------------------------------------

    return array2;
};

export const transposeArray = (array) => { 
    try {
        return array[0].map((col, i) => array.map(row => row[i]));

        //--------------------------------------------------------------------------------------
        // Passing tests
        //
        // let a = transposeArray([
        //     [1, 2]
        // ]);                          
        // console.log(clone(a)); 
        // a[0][0] = "test"; 
        // console.log(clone(a));
        // let a2 = transposeArray(a); 
        // console.log(a2); 
        // let a3 = transposeArray(a2); 
        // console.log(a3);
        // let a4 = transposeArray(a3); 
        // console.log(a4); 
        // console.log(""); 
        // console.log(""); 
        // console.log(""); 
        //
        // let b = transposeArray([
        //     [1, 2], 
        //     [3, 4]
        // ]);         
        // console.log(clone(b)); 
        // b[0][0] = "test"; 
        // console.log(clone(b));
        // let b2 = transposeArray(b); 
        // console.log(b2); 
        // let b3 = transposeArray(b2); 
        // console.log(b3);
        // let b4 = transposeArray(b3); 
        // console.log(b4); 
        // console.log(""); 
        // console.log(""); 
        // console.log(""); 
        //
        // let c = transposeArray([
        //     [1, 2], 
        //     [3, 4], 
        //     [5, 6]
        // ]);          
        // console.log(clone(c)); 
        // c[0][0] = "test"; 
        // console.log(clone(c));
        // let c2 = transposeArray(c); 
        // console.log(c2); 
        // let c3 = transposeArray(c2); 
        // console.log(c3);
        // let c4 = transposeArray(c3); 
        // console.log(c4); 
        // console.log(""); 
        // console.log(""); 
        // console.log(""); 
        //
        // let d = transposeArray([
        //     [{ intArray : 1 }, 2], 
        //     [3, 4], 
        //     [5, { intArray : 6 }]
        // ]);          
        // console.log(clone(d)); 
        // d[0][0].intArray = "test"; 
        // console.log(clone(d));
        // let d2 = transposeArray(d); 
        // console.log(d2); 
        // let d3 = transposeArray(d2); 
        // console.log(d3);
        // let d4 = transposeArray(d3); 
        // console.log(d4); 
        // console.log(""); 
        // console.log(""); 
        // console.log(""); 
        //--------------------------------------------------------------------------------------
    }
    catch(e) {
        console.error(e);
        debugger;
    }
};    

//=======================================================================================================
//
//       ########     ###     ######  ##    ## ########    ###    ########  ##       ######## 
//       ##     ##   ## ##   ##    ## ##   ##     ##      ## ##   ##     ## ##       ##       
//       ##     ##  ##   ##  ##       ##  ##      ##     ##   ##  ##     ## ##       ##       
//       ########  ##     ## ##       #####       ##    ##     ## ########  ##       ######   
//       ##        ######### ##       ##  ##      ##    ######### ##     ## ##       ##       
//       ##        ##     ## ##    ## ##   ##     ##    ##     ## ##     ## ##       ##       
//       ##        ##     ##  ######  ##    ##    ##    ##     ## ########  ######## ########
//
//=======================================================================================================

export const transposePackTable = (packTable) => {

    let o = clone(packTable);

    o.GBRowCount = packTable.GBColCount;
    o.GBColCount = packTable.GBRowCount;
    o.GBFixedRows = packTable.GBFixedCols;
    o.GBFixedCols = packTable.GBFixedRows;
    o.TotalRow = packTable.TotalRow;
    o.TotalCol = packTable.TotalCol;
    o.RowIds = clone(packTable.ColIds);
    o.ColIds = clone(packTable.RowIds);

    o.tableData.value = transposeArray(packTable.tableData.value);

    o.RDec = transposeArray(packTable.RDec);
    o.MinAllowedVal = transposeArray(packTable.MinAllowedVal);
    o.MaxAllowedVal = transposeArray(packTable.MaxAllowedVal);
    o.FontStyles = transposeArray(packTable.FontStyles);
    o.FontColors = transposeArray(packTable.FontColors);
    o.BGColors = transposeArray(packTable.BGColors);
    o.GBCellComment = transposeArray(packTable.GBCellComment);
    o.GBUseTriangle = transposeArray(packTable.GBUseTriangle);
    o.LockedCells = transposeArray(packTable.LockedCells);

    o.HasCheckBox = transposeArray(packTable.HasCheckBox);
    o.CheckBoxState = transposeArray(packTable.CheckBoxState);
    o.Alignments = transposeArray(packTable.Alignments);

    o.WordWrappedCols = createVector(o.GBColCount, false);
    o.GBRowHeights = createVector(o.GBRowCount, -1);
    o.GBColWidths = createVector(o.GBColCount, -1);
    o.IndentRowText = createVector(o.GBRowCount, { xoffset: 0, Value: false });
    o.RowSubHeadings = createVector(o.GBRowCount, false);
    
    o.Title = packTable.Title;
    o.editorMstID = packTable.editorMstID;
    o.Proj = packTable.Proj;
    o.ModID = packTable.ModID;
    o.MergedCells = [];
    o.SourceMode = packTable.SourceMode;
    o.SourceMap = [];
    o.Source = packTable.Source;

    return o;
};

export const resizePackTable = (packTable, rowCount, columnCount) => {

    let table = clone(packTable);

    table.GBRowCount = rowCount;
    table.GBColCount = columnCount;

    table.tableData.value = size2dArray(packTable.tableData.value, rowCount, columnCount, "");
    table.WordWrappedCols = size1dArray(packTable.WordWrappedCols, columnCount, false);
    table.RDec = size2dArray(packTable.RDec, rowCount, columnCount, 0);
    table.MinAllowedVal = size2dArray(packTable.MinAllowedVal, rowCount, columnCount, 0);
    table.MaxAllowedVal = size2dArray(packTable.MaxAllowedVal, rowCount, columnCount, 0);
    table.FontStyles = size2dArray(packTable.FontStyles, rowCount, columnCount, { intArray: [] });
    table.FontColors = size2dArray(packTable.FontColors, rowCount, columnCount, "#000");
    table.BGColors = size2dArray(packTable.BGColors, rowCount, columnCount, 536870911);
    table.GBCellComment = size2dArray(packTable.GBCellComment, rowCount, columnCount, "");
    table.GBUseTriangle = size2dArray(packTable.GBUseTriangle, rowCount, columnCount, false);
    table.LockedCells = size2dArray(packTable.LockedCells, rowCount, columnCount, false);
    table.IndentRowText = size1dArray(packTable.IndentRowText, rowCount, { xoffset: 0, Value: false });
    table.RowSubHeadings = size1dArray(packTable.RowSubHeadings, rowCount, false);
    table.HasCheckBox = size2dArray(packTable.HasCheckBox, rowCount, columnCount, false);
    table.CheckBoxState = size2dArray(packTable.CheckBoxState, rowCount, columnCount, false);
    table.Alignments = size2dArray(packTable.Alignments, rowCount, columnCount, 0);
    table.RowIds = size2dArray(packTable.RowIds, rowCount, 2, 0);
    table.ColIds = size2dArray(packTable.ColIds, columnCount, 2, 0);
    table.GBRowHeights = size1dArray(packTable.GBRowHeights, rowCount, -1);
    table.GBColWidths = size1dArray(packTable.GBColWidths, columnCount, -1);

    // table.GBFixedRows = packTable.GBFixedRows;
    // table.GBFixedCols = packTable.GBFixedCols;
    // table.TotalRow = packTable.TotalRow;
    // table.TotalCol = packTable.TotalCol;

    // table.MergedCells = [];

    // table.Title = packTable.Title;
    // table.editorMstID = packTable.editorMstID;
    // table.Proj = packTable.Proj;
    // table.ModID = packTable.ModID;

    // table.SourceMode = packTable.SourceMode;
    // table.SourceMap = [];
    // table.Source = packTable.Source;

    return table;
};

export const addMergedCellsToArray = (array, startRow, startCol, numRows, numCols) => {

    let array1 = JSON.parse(JSON.stringify(array));

    array1[array1.length] = {
        "startCol" : startCol,
        "startRow" : startRow,
        "numCols" : numCols,
        "numRows" : numRows
    };

    return (array1);
};

export const addRowToPackTable = (pt, defaultVal = 0, rDec = 0) => {
    let packTable = resizePackTable(pt, pt.GBRowCount + 1, pt.GBColCount);
    
    let r = packTable.GBRowCount - 1;
    for (let c = 0; c < packTable.GBColCount; c++) {
        packTable.RDec[r][c] = rDec;
        packTable.tableData.value[r][c] = defaultVal;
    }

    return packTable;
};

export const addTitleRowToPackTable = (pt, title, numCols, indent = false, isProjTitle = false) => {
    pt = resizePackTable(pt, pt.tableData.value.length + 1, numCols);

    // pt.tableData[pt.tableData.length] = [];             //add a row
    pt.tableData.value[pt.tableData.value.length - 1][0] = title;  //add title to newly created row

    if (indent) {
        pt.IndentRowText[pt.IndentRowText.length - 1].xoffset = 15;
        pt.IndentRowText[pt.IndentRowText.length - 1].value = true;
    } else {
        pt.IndentRowText[pt.IndentRowText.length - 1].xoffset = 0;
        pt.IndentRowText[pt.IndentRowText.length - 1].value = false;
    }

    addMergedCellsToArray(pt.MergedCells, pt.tableData.length - 1, 0, 1, numCols);

    return pt;
};

export const addDataRowToPackTable = (pt, rowData, RDec = 0, indent = false) => {
    pt = resizePackTable(pt, pt.tableData.value.length + 1, rowData.length);

    // pt.tableData[pt.tableData.length] = [];             //add a row
    for (let y = 0; y <= (rowData.length - 1); y++) {   //copy row data into new row
        pt.tableData.value[pt.tableData.value.length - 1][y] = rowData[y];
    }
    // pt.GBRowCount = pt.tableData.length;

    // pt.RDec[pt.RDec.length] = [];                       //add a row
    for (let y = 0; y <= (rowData.length - 1); y++) {   //copy row data into new row
        pt.RDec[pt.RDec.length - 1][y] = RDec;
    }

    if (indent) {
        pt.IndentRowText[pt.IndentRowText.length - 1].xoffset = 15;
        pt.IndentRowText[pt.IndentRowText.length - 1].value = true;
    } else {
        pt.IndentRowText[pt.IndentRowText.length - 1].xoffset = 0;
        pt.IndentRowText[pt.IndentRowText.length - 1].value = false;
    }

    return pt;
};

export const mergeAndTransposePackTables = (sourcePT, destPT, title, indent = false, noDataFYear = false) => {

    //adds the data row of a 'years as rows' PT to a 'years as cols' PT.
    // noDataFYear should be true if there is no data in first year AND first year of projection is included in the PT.
    let packTable = resizePackTable(destPT, destPT.tableData.value.length + 1, destPT.tableData.value[0].length);

    packTable.tableData.value[packTable.tableData.value.length - 1][0] = title;
    for (let y = 1; y <= (sourcePT.tableData.value.length - 1); y++) {   //copy row data into new row
        if (noDataFYear && (y === 1)) {
            packTable.RDec[packTable.RDec.length - 1][y] = ' - ';
        }
        else {
            packTable.tableData.value[packTable.tableData.value.length - 1][y] = sourcePT.tableData.value[y][1]
        }
    }

    for (let y = 1; y <= (sourcePT.RDec.length - 1); y++) {   //copy row data into new row
        packTable.RDec[packTable.RDec.length - 1][y] = sourcePT.RDec[y][1];
    }

    if (indent) {
        packTable.IndentRowText[packTable.IndentRowText.length - 1].xoffset = 15;
        packTable.IndentRowText[packTable.IndentRowText.length - 1].value = true;
    } else {
        packTable.IndentRowText[packTable.IndentRowText.length - 1].xoffset = 0;
        packTable.IndentRowText[packTable.IndentRowText.length - 1].value = false;
    }

    return packTable;
};

//=======================================================================================================
//
//                        #######  ######## ##     ## ######## ########  
//                       ##     ##    ##    ##     ## ##       ##     ## 
//                       ##     ##    ##    ##     ## ##       ##     ## 
//                       ##     ##    ##    ######### ######   ########  
//                       ##     ##    ##    ##     ## ##       ##   ##   
//                       ##     ##    ##    ##     ## ##       ##    ##  
//                        #######     ##    ##     ## ######## ##     ##
//
//=======================================================================================================

export const hash = function(s, seed = 0) {
    let h1 = 0xdeadbeef ^ seed;
    let h2 = 0x41c6ce57 ^ seed;

    for (let i = 0, c; i < s.length; i++) {
        c = s.charCodeAt(i);
        h1 = Math.imul(h1 ^ c, 2654435761);
        h2 = Math.imul(h2 ^ c, 1597334677);
    }

    h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507) ^ Math.imul(h2 ^ (h2 >>> 13), 3266489909);
    h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507) ^ Math.imul(h1 ^ (h1 >>> 13), 3266489909);

    return 4294967296 * (2097151 & h2) + (h1 >>> 0);
};

export const GBStringify = obj => {

    function stringify(obj, options) {
        // https://github.com/lydell/json-stringify-pretty-compact/blob/master/index.js + custom changes
    
        options = options || {};
        var indent = JSON.stringify([1], null, getSomethingForStringify(options, "indent", 2)).slice(2, -3);
        var addMargin = getSomethingForStringify(options, "margins", false);
        var maxLength = indent === "" ? Infinity : getSomethingForStringify(options, "maxLength", 80);
    
        return (function _stringify(obj, currentIndent, reserved) {
            if (obj && typeof obj.toJSON === "function") {
                obj = obj.toJSON();
            }
    
            var string = JSON.stringify(obj);
    
            if (string === undefined) {
                return string;
            }
    
            var length = maxLength - currentIndent.length - reserved;
    
            if (string.length <= length) {
                if (string[0] !== "{") {
                    // TGP
                    if (!(string[0] === "[" && string[1] === "[")) {
                        // TGP
                        if (!(string[0] === "[" && string[1] === "{")) {
                            // TGP
                            var prettified = prettify(string, addMargin);
                            if (prettified.length <= length) {
                                return prettified;
                            }
                        }
                    }
                }
            }
    
            if (typeof obj === "object" && obj !== null) {
                var nextIndent = currentIndent + indent;
                var items = [];
                var delimiters;
                var comma = function(array, index) {
                    return index === array.length - 1 ? 0 : 1;
                };
    
                if (Array.isArray(obj)) {
                    for (var index = 0; index < obj.length; index++) {
                        items.push(_stringify(obj[index], nextIndent, comma(obj, index)) || "null");
                    }
                    delimiters = "[]";
                } else {
                    Object.keys(obj).forEach(function(key, index, array) {
                        var keyPart = JSON.stringify(key) + ": ";
                        var value = _stringify(obj[key], nextIndent, keyPart.length + comma(array, index));
                        if (value !== undefined) {
                            items.push(keyPart + value);
                        }
                    });
                    delimiters = "{}";
                }
    
                if (items.length > 0) {
                    return [delimiters[0], indent + items.join(",\n" + nextIndent), delimiters[1]].join(
                        "\n" + currentIndent
                    );
                }
            }
    
            return string;
        })(obj, "", 0);
    }
    
    function prettify(string, addMargin) {
        // Note: This regex matches even invalid JSON strings, but since we’re
        // working on the output of `JSON.stringify` we know that only valid strings
        // are present (unless the user supplied a weird `options.indent` but in
        // that case we don’t care since the output would be invalid anyway).
        var stringOrChar = /("(?:[^\\"]|\\.)*")|[:,\][}{]/g;
    
        var m = addMargin ? " " : "";
        var tokens = {
            "{": "{" + m,
            "[": "[" + m,
            "}": m + "}",
            "]": m + "]",
            ",": ", ",
            ":": ": "
        };
        return string.replace(stringOrChar, function(match, string) {
            return string ? match : tokens[match];
        });
    }
    
    function getSomethingForStringify(options, name, defaultValue) {
        return name in options ? options[name] : defaultValue;
    }

    var str = stringify(obj, { indent: 4, maxLength: Infinity });

    return str;

    // document.getElementById("myJSON2").innerHTML = str;
    // var prettyText = syntaxHighlight(str);
    // document.getElementById("responseConverted").innerHTML = prettyText;
};

//------------------------------------------------------------------------------------------------------

export const copyToClipboard = text => {
    const element = document.createElement("textarea");

    element.value = text;

    element.setAttribute("readonly", "");
    element.style.position = "absolute";
    element.style.left = "-9999px";

    let anchorElement = document.body;

    const anchorElements = document.getElementsByClassName("clipboard-anchor");

    if (anchorElements && anchorElements.length) {
        anchorElement = anchorElements[0];
    }

    anchorElement.appendChild(element);

    const selected = document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false;

    element.select();
    document.execCommand("copy");

    anchorElement.removeChild(element);

    if (selected) {
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(selected);
    }
};

export const copyJStoClipboard = obj => {
    const str = GBStringify(obj);
    copyToClipboard(str);
};

export const copyJsonToClipboard = text => {
    // TGP Convert to a nicer format
    const obj = JSON.parse(text);
    const str = GBStringify(obj);
    copyToClipboard(str);
};

export const fieldToColumnIndex = field => parseInt(field.substring(fieldNamePrefix.length), 10) - 1;

export const formatNumber = (value, decimalPlaces, showThousandsSeparator) => {
    let minimumFractionalDigits = decimalPlaces;
    let maximumFractionalDigits = decimalPlaces;

    if (!decimalPlaces && decimalPlaces !== 0) {
        minimumFractionalDigits = 0;
        maximumFractionalDigits = 20;
    }

    if (!isNumeric(value)) {
        return value;
    }

    const number = parseFloat(value);

    return !showThousandsSeparator
        ? number.toFixed(decimalPlaces)
        : number.toLocaleString("en-US", {
              minimumFractionDigits: minimumFractionalDigits,
              maximumFractionDigits: maximumFractionalDigits
          });
};

export const isNumeric = value => (value || value === 0) && !isNaN(value);

export const toDelimitedText = (packTable, delimiter) =>
    packTable.tableData.value.map(row => Object.values(row).join(delimiter)).join("\n");

export const toCsv = packTable => toDelimitedText(packTable, ",");
